module.exports = __webpack_public_path__ + "fonts/Noto_Sans_TC-400-104.fe0ac4f.woff2";